import React from 'react';
import { Breadcrumb, Layout, Menu } from 'antd';
const { Header, Content, Footer } = Layout;

function Footersection() {
  return (
    <Footer style={{ textAlign: 'center' }}>
      SpaceX360 2022 Created by Jahid for Demo of React + Redux + AntD
    </Footer>
  );
}

export default Footersection;
